import styled from "styled-components";
import Variables from "../styleVariables";

// export const Box = styled.div`
//   //max-width: calc(410px + 32px);
//   width: 100%;
//   margin-top: 10px;
//   padding: 10px 16px;
//   border-radius: 5px;
//   background-color: ${Variables.colors.complementary_200};
//   color: ${Variables.colors.complementary_800};
//
//   .event-info-icon {
//     width: 40px;
//     height: 40px;
//     display: flex;
//     -webkit-box-pack: center;
//     justify-content: center;
//     -webkit-box-align: center;
//     align-items: center;
//     cursor: pointer;
//     border-radius: 50%;
//     &:before {
//       font-size: 20px;
//       color: ${Variables.colors.complementary_600};
//       margin: 0px;
//     }
//     &:hover {
//       background-color: ${Variables.colors.complementary_400};
//     }
//   }
// `;

export const Box = styled.div`
  margin-top: 10px;
  padding: 10px 16px;
  border-radius: 5px;
  width: 100%;
  background-color: ${Variables.colors.complementary_200};
  color: ${Variables.colors.complementary_800};

  // .info-icon {
  //   width: 40px;
  //   height: 40px;
  //   border-radius: 50%;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   margin-right: 8px;
  //   cursor: pointer;
  //   &:before {
  //     font-size: 20px;
  //     color: ${Variables.colors.complementary_600};
  //   }
  //   &:hover {
  //     background-color: ${Variables.colors.complementary_400};
  //   }
  // }

  .title {
    font-size: ${Variables.font_sizes.x_medium};
    line-height: 1.6;
  }
  
  .header-inner-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;